import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./components/DynamicForms/DynamicForms.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/index";
import GetItemFromLocalstorage from "Utils/GetItemFromLocalstorage";
import { cacheCareSector } from "Utils/utils";
import { authenticatedUser } from "store/actions/auth.actions";
import ErrorBoundary from "./components/common/ErrorBoundary/ErrorBoundary";

const user = GetItemFromLocalstorage("user");

if (user) {
  cacheCareSector(user);
  store.dispatch(authenticatedUser(user));
}

ReactDOM.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>,
  // </React.StrictMode>,
  document.getElementById("root")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
